import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import useAppUpdatePending from './useAppUpdatePending';

function triggerReload() {
  if (sessionStorage.getItem('appJustReloaded')) return;
  sessionStorage.setItem('appJustReloaded', '1');
  window.location.reload();
}

export default function useAutoReloadOnUpdate() {
  const updatePending = useAppUpdatePending();
  const { pathname } = useLocation();
  const lastPathnameRef = useRef(pathname);

  useEffect(() => {
    if (pathname === lastPathnameRef.current) return undefined;
    lastPathnameRef.current = pathname;
    if (import.meta.env.MODE !== 'production') return undefined;
    if (updatePending) triggerReload();
    return undefined;
  }, [pathname, updatePending]);
}
